import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('put', `/api/users/${id}/update-user-email`, payload);


// WEBPACK FOOTER //
// ./src/app/services/account/updateUserEmail.js